import { apiClient } from '@/shared/api/http-client';

import { practiceMemberUsageOutputSchema } from '../model/reporting.schemas';
import type { PracticeMemberUsageInput, PracticeMemberUsageOutput } from '../model/reporting.types';

export const reportingApi = {
    list: async (
        params: PracticeMemberUsageInput,
        signal?: AbortSignal,
    ): Promise<PracticeMemberUsageOutput> => {
        const query = new URLSearchParams();
        if (params.search) query.set('search', params.search);
        if (params.sortBy) query.set('sortBy', params.sortBy);
        if (params.sortDirection) query.set('sortDirection', params.sortDirection);
        if (params.cursor) query.set('cursor', params.cursor);
        if (params.asOf) query.set('asOf', params.asOf);

        const queryString = query.toString();
        const data = await apiClient.get(
            `/reporting/practice-members${queryString ? `?${queryString}` : ''}`,
            { signal },
        );
        return practiceMemberUsageOutputSchema.parse(data);
    },
};
